var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
// One slot as the ERP editor sees it: the working draft and what is live.
export class D2CSiteContentSlotDto {
    constructor(initializer) {
        this.slot = initializer.slot;
        this.draftValue = initializer.draftValue;
        this.draftVersion = initializer.draftVersion;
        this.draftUpdatedAt = initializer.draftUpdatedAt;
        this.draftUpdatedByName = initializer.draftUpdatedByName;
        this.publishedValue = initializer.publishedValue;
        this.publishedRevisionId = initializer.publishedRevisionId;
        this.publishedAt = initializer.publishedAt;
        this.publishedByName = initializer.publishedByName;
        this.hasUnpublishedChanges = initializer.hasUnpublishedChanges;
    }
}
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], D2CSiteContentSlotDto.prototype, "draftUpdatedAt", void 0);
__decorate([
    Type(() => Date),
    __metadata("design:type", Object)
], D2CSiteContentSlotDto.prototype, "publishedAt", void 0);
